import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Dashboard } from './pages/Dashboard';
import { Overview } from './pages/Overview';
import { StockDetail } from './pages/StockDetail';
import { BrokeragesPage } from './pages/BrokeragesPage';
import TopStocks from './pages/TopStocks';
import { MainLayout } from './layouts/MainLayout';
import SplashScreen from './components/SplashScreen';
import PWAManager from './components/PWAInstallPrompt'; // Import PWAManager
import './styles/main.css';

// Component to handle splash screen logic
const AppContent: React.FC = () => {
  const [showSplash, setShowSplash] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Check if splash has been shown in this session
    const splashShown = sessionStorage.getItem('splash_shown');
    
    // Only show splash on initial load if not shown before
    if (splashShown) {
      setShowSplash(false);
    }
  }, []);

  // If splash is active and we are at root, show splash
  // Otherwise render routes
  if (showSplash && location.pathname === '/') {
    return <SplashScreen />;
  }

  return (
    <>
      <PWAManager /> {/* Initialize PWA features globally */}
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Navigate to="/overview" replace />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/brokerages" element={<BrokeragesPage />} />
          <Route path="/top-stocks" element={<TopStocks />} />
          <Route path="/stock/:symbol" element={<StockDetail />} />
        </Route>
        {/* Standalone route for testing splash if needed */}
        <Route path="/splash" element={<SplashScreen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <Router>
        <AppContent />
      </Router>
    </ErrorBoundary>
  );
};

export default App;